import { Salonized } from '../translations-types';

const translations: Salonized = {
  title: 'Salonized connection',
  description: 'Connect your Salonized account so the schedule can be shown per employee in Re-sence.',
  connected: 'Connected',
  notConnected: 'Not connected',
  connectedAs: 'Connected as',
  email: 'Salonized email',
  password: 'Salonized password',
  url: 'Salonized calendar URL',
  urlHelp: 'E.g. https://app.salonized.com/c/1234/l/1234/calendar',
  connect: 'Connect',
  disconnect: 'Disconnect',
  connectSuccess: 'Salonized connected',
  disconnectSuccess: 'Salonized disconnected',
  sync: 'Sync now',
  syncPastYear: 'Sync past year',
  deleteAppointments: 'Delete all appointments',
  deleteAppointmentsConfirm: 'Are you sure you want to delete all synced appointments?',
  deleteAppointmentsSuccess: 'All synced appointments deleted',
  syncing: 'Syncing…',
  syncDone: 'Sync complete',
  added: 'Added',
  updated: 'Updated',
  removed: 'Removed',
  matchedCustomers: 'Matched customers',
  unmatchedCustomers: 'Unmatched customers',
  ambiguous: 'Multiple matches',
};

export default translations;
